import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Menu, Item } from 'react-contexify';

import 'react-contexify/dist/ReactContexify.css';
import { makeStyles } from '@material-ui/core/styles';

import InsertLinkIcon from '@material-ui/icons/InsertLink';
import FileCopyIcon from '@material-ui/icons/FileCopyOutlined';

const useStyles = makeStyles(theme => ({
  menu: {
    zIndex: 1200
  },
  iconStyle: {
    color: 'inherit',
    marginRight: '5px'
  },
  menuItem: {
    '& > .react-contexify__item__content > svg': {
      color: theme.palette.primary.main
    },
    '&:hover > .react-contexify__item__content  > svg': {
      color: '#fff'
    }
  }
}));
const TABLE_CONTEXT_MENU_ID = 'TABLE_CONTEXT_MENU_ID';

const TableContextMenu = memo(({ handleAnchorItemClick, handleCopyItemClick }) => {
  const classes = useStyles();
  return (
    <Menu className={classes.menu} id={TABLE_CONTEXT_MENU_ID}>
      <Item onClick={handleAnchorItemClick} className={classes.menuItem} data="target_blank">
        <InsertLinkIcon className={classes.iconStyle} />
        Open in new tab
      </Item>
      <Item onClick={handleCopyItemClick} className={classes.menuItem} data="copy">
        <FileCopyIcon className={classes.iconStyle} />
        Copy Link Address
      </Item>
    </Menu>
  );
});

TableContextMenu.propTypes = {
  handleAnchorItemClick: PropTypes.func.isRequired,
  handleCopyItemClick: PropTypes.func.isRequired
};

export default TableContextMenu;
